import script from "./Questions.vue?vue&type=script&setup=true&lang=js"
export * from "./Questions.vue?vue&type=script&setup=true&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=7573cf74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7573cf74"]])

export default __exports__